<div style="display:flex; flex-direction:row; flex-grow:1; overflow:hidden;">
    <div style="display:flex; flex-direction:column; flex:1; overflow:hidden;">
        <tyl-kendo-pdf-export [keepTogether]="'.mat-row'" class="tylKendoPdf">
            <div class="flex-header">
                <student-header [pageTitle]="'Documents'" [showYearSelector]="false"></student-header>
            </div>
            <div class="flex-content">
                <div style="text-align:center;" *ngIf="studentDocuments && studentDocuments.length == 0" translate>
                    No Documents data exists for student.
                </div>
                <div style="height:100px; overflow:auto;flex-grow:1;"
                    *ngIf="studentDocuments && studentDocuments.length > 0"><!--  Height is set to an arbitrary number initially in order for flex to work. -->
                    <!-- Angular Material table definition -->
                    <mat-table #table [dataSource]="angularMatData" matSort matSortDisableClear id="SDdataTable"
                        style="min-width: 905px;" matSortActive="CreatedOn" matSortDirection="desc"
                        aria-label="Student Documents Table" tabindex="0">
                        <!-- Individual column definitions -->
                        <ng-container matColumnDef="Name">
                            <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:200px;margin-right:20px;">
                                <span translate>File Name</span>
                                <filter [data]="angularMatData" columnName="Name" dataType="string"></filter>
                            </mat-header-cell>
                            <mat-cell *matCellDef="let SD" style="min-width:200px;margin-right:20px;">
                                <a (click)="viewAttachment(SD)" class="link">{{SD.Name}}</a>
                            </mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="DocumentType">
                            <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:150px;margin-right:20px;">
                                <span translate>Document Type</span>
                                <filter [data]="angularMatData" columnName="DocumentType" dataType="string"></filter>
                            </mat-header-cell>
                            <mat-cell *matCellDef="let SD" style="min-width:150px;margin-right:20px;">{{SD.DocumentType}}
                            </mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="FileType">
                            <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:100px;margin-right:20px;">
                                <span translate>File Type</span>
                                <filter [data]="angularMatData" columnName="FileType" dataType="string"></filter>
                            </mat-header-cell>
                            <mat-cell *matCellDef="let SD" style="min-width:100px;margin-right:20px;">{{SD.FileType}}
                            </mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="Notes">
                            <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:200px;margin-right:20px;">
                                <span translate>Description/Comments</span>
                                <filter [data]="angularMatData" columnName="Notes" dataType="string"></filter>
                            </mat-header-cell>
                            <mat-cell *matCellDef="let SD" style="min-width:200px;margin-right:20px;">{{SD.Notes}}
                            </mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="CreatedOn">
                            <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:100px;margin-right:20px;">
                                <span translate>Created</span>
                                <filter [data]="angularMatData" columnName="CreatedOn" dataType="date"></filter>
                            </mat-header-cell>
                            <mat-cell *matCellDef="let SD" style="min-width:100px;margin-right:20px;">
                                {{SD.CreatedOn | date:'MM/dd/yy'}}</mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="CreatedBy">
                            <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:100px;margin-right:20px;">
                                <span translate>Created</span>
                                <filter [data]="angularMatData" columnName="CreatedBy" dataType="string"></filter>
                            </mat-header-cell>
                            <mat-cell *matCellDef="let SD" style="min-width:100px;margin-right:20px;">{{SD.CreatedBy}}
                            </mat-cell>
                        </ng-container>

                        <mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true" id="SDdataHeader">
                        </mat-header-row>
                        <!-- Data rows -->
                        <mat-row *matRowDef="let row; columns: columnsToDisplay; let i = index;" id="SDdataRow{{i}}"
                            tabindex="0" [attr.aria-label]="getAriaRow(row)"
                            style="padding:0px;overflow:hidden;border-bottom-width:1px;" matRipple>
                        </mat-row>
                    </mat-table>
                </div>
            </div>
        </tyl-kendo-pdf-export>    
        <div class="flex-footer">
            <!-- Left -->
            <div class="flex-footer-left">
                <tyl-button [image]="filtered ? 'filter yellow.png' : 'filter.png'" label="Filter"
                    (click)="showFilterClick()"></tyl-button>
            </div>

            <!-- Middle -->
            <div class="flex-footer-middle" style="align-items: center">
                <filter-notification [filtered]="filtered || angularMatData.isFiltered()"
                    (clearFilter)="clearFilterFromFooter()"></filter-notification>
            </div>

            <!-- Right -->
            <div class="flex-footer-right">

            </div>
        </div>
    </div>

    <!-- Filter Panel -->

    <div *ngIf="showFilter" class="filter-body">
        <div class="flex-header sis-app-header-label" style="font-weight:bold; font-size:20px;" translate>
            Filter
        </div>

        <div class="flex-content">

            <!-- File Name -->
            <label translate>File Name</label>
            <tyl-form-field>
                <input matInput name="fileNameFilter" id="filterFileNameField" [ngModel]="filter.fileName"
                    (ngModelChange)="filter.fileName = $event; applyFilter();">
            </tyl-form-field>

            <!-- Document Type -->
            <label translate>Document Type</label>
            <tyl-form-field>
                <input matInput name="documentTypeFilter" id="filterDocumentTypeField" [ngModel]="filter.documentType"
                    (ngModelChange)="filter.documentType = $event; applyFilter();">
            </tyl-form-field>

            <!-- File Type -->
            <label translate>File Type</label>
            <tyl-form-field>
                <input matInput name="fileTypeFilter" id="filterFileTypeField" [ngModel]="filter.fileType"
                    (ngModelChange)="filter.fileType = $event; applyFilter();">
            </tyl-form-field>

            <!-- Description/Comments -->
            <label translate>Description/Comments</label>
            <tyl-form-field>
                <input matInput name="descriptionFilter" id="filterDescriptionField" [ngModel]="filter.description"
                    (ngModelChange)="filter.description = $event; applyFilter();">
            </tyl-form-field>

            <!-- Created -->
            <label translate>Created</label>
            <tyl-datepicker label="From" id="filterCreatedFromField" [value]="filter.createdFrom"
                (valueChange)="filter.createdFrom = $event; applyFilter();"></tyl-datepicker>
            <tyl-datepicker label="To" id="filterCreatedToField" [value]="filter.createdTo"
                (valueChange)="filter.createdTo = $event; applyFilter();"></tyl-datepicker>
        </div>

        <div class="filter-flex-footer">

            <!-- Left Buttons -->
            <tyl-button image="startover.png" label="Clear" (clickEvent)="clearFilter()"></tyl-button>

            <!-- Right Buttons -->
            <div class="footerRight">
                <tyl-button image="Cancel.png" label="Close" (clickEvent)="closeFilter()"></tyl-button>
            </div>
        </div>
    </div>

</div>